import React, { useEffect, useState } from "react";

import {
    faBoxes,
    faArrowUp,
    faArrowDown,
    faSearch
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
    getAjustes,
    guardarAjuste,
    buscarProductos
} from "../../../services/ajusteinventarioservice";

import { toast, ToastContainer } from "react-toastify";

import "./AjusteInventario.css";

export default function AjusteInventario() {

    const user = JSON.parse(localStorage.getItem("user"));

    const [ajustes, setAjustes] = useState([]);

    const [loading, setLoading] = useState(false);

    const [busqueda, setBusqueda] = useState("");

    const [resultados, setResultados] = useState([]);

    const [mostrarLista, setMostrarLista] = useState(false);

    const [productoSeleccionado, setProductoSeleccionado] = useState(null);

    const [form, setForm] = useState({
        idproducto: "",
        tipo: "Entrada",
        cantidad: "",
        descripcion: "",
        referencia: ""
    });

    // ================= CARGAR =================

    const cargar = async () => {

        try {

            const ajustesData = await getAjustes();

            setAjustes(Array.isArray(ajustesData) ? ajustesData : []);

        } catch (error) {

            console.error(error);

            toast.error("Error cargando ajustes");
        }
    };

    useEffect(() => {

        cargar();

    }, []);

    // ================= BUSCAR =================

    const handleBuscar = async (text) => {

        setBusqueda(text);

        setProductoSeleccionado(null);

        if (!text || text.trim().length < 2) {

            setResultados([]);

            setMostrarLista(false);

            return;
        }

        try {

            const data = await buscarProductos(text);

            setResultados(Array.isArray(data) ? data : []);

            setMostrarLista(true);

        } catch (error) {

            console.error(error);

            toast.error("Error buscando productos");
        }
    };

    // ================= SELECCIONAR =================

    const seleccionarProducto = (p) => {

        setProductoSeleccionado(p);

        setForm(prev => ({
            ...prev,
            idproducto: p.idproducto
        }));

        setBusqueda(p.nombre);

        setResultados([]);

        setMostrarLista(false);
    };

    // ================= FILTRAR MOVIMIENTOS =================

    const movimientosProducto = ajustes.filter(
        (a) => a.idproducto === productoSeleccionado?.idproducto
    );

    // ================= GUARDAR =================

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!form.idproducto) {

            toast.error("Seleccione un producto");

            return;
        }

        if (!form.cantidad || Number(form.cantidad) <= 0) {

            toast.error("Cantidad inválida");

            return;
        }

        setLoading(true);

        try {

            const payload = {
                idproducto: form.idproducto,
                tipo: form.tipo,
                cantidad: form.cantidad,
                descripcion: form.descripcion,
                referencia: form.referencia,
                idusuario: user?.idusuario
            };

            const res = await guardarAjuste(payload);

            if (res?.result?.status === "success") {

                const nuevoStock =
                    Number(res?.result?.nuevoStock || 0);

                // Actualiza la tarjeta seleccionada
                setProductoSeleccionado(prev => ({
                    ...prev,
                    stock: nuevoStock
                }));

                // Actualiza los resultados de búsqueda
                setResultados(prev =>
                    prev.map(p =>
                        Number(p.idproducto) === Number(form.idproducto)
                            ? { ...p, stock: nuevoStock }
                            : p
                    )
                );

                toast.success("Ajuste registrado");

                setForm({
                    idproducto: productoSeleccionado.idproducto,
                    tipo: "Entrada",
                    cantidad: "",
                    descripcion: "",
                    referencia: ""
                });

                cargar();


            } else {

                toast.error(res?.message || "Error al guardar");
            }

        } catch (error) {

            console.error(error);

            toast.error("Error servidor");
        }

        setLoading(false);
    };

    return (

        <div className="main-content">

            <ToastContainer />

            {/* CARD */}
            <div className="ajuste-card">

                {/* BUSCADOR */}
                <div className="search-wrapper ajuste-search">

                    <FontAwesomeIcon
                        icon={faSearch}
                        className="search-icon"
                    />

                    <input
                        className="search-input"
                        placeholder="Buscar producto..."
                        value={busqueda}
                        onChange={(e) => handleBuscar(e.target.value)}
                        autoComplete="off"
                    />

                    {mostrarLista && resultados.length > 0 && (

                        <div className="resultados-box">

                            {resultados.map((p) => (

                                <div
                                    key={p.idproducto}
                                    className="resultado-item"
                                    onClick={() => seleccionarProducto(p)}
                                >

                                    {p.imagen ? (

                                        <img
                                            src={`https://jm.komerzy.com/backend/${p.imagen}`}
                                            alt={p.nombre}
                                            className="resultado-img"
                                        />

                                    ) : (

                                        <div className="resultado-placeholder">
                                            Sin Img
                                        </div>

                                    )}

                                    <div className="resultado-info">

                                        <span className="resultado-nombre">
                                            {p.nombre}
                                        </span>

                                        <span className="resultado-stock">
                                            Stock: {p.stock}
                                        </span>

                                    </div>

                                </div>

                            ))}

                        </div>

                    )}

                </div>

                {/* PRODUCTO */}
                {productoSeleccionado && (

                    <>

                        <div className="producto-seleccionado">

                            {productoSeleccionado.imagen ? (

                                <img
                                    src={`https://jm.komerzy.com/backend/${productoSeleccionado.imagen}`}
                                    alt={productoSeleccionado.nombre}
                                    className="producto-seleccionado-img"
                                />

                            ) : (

                                <div className="producto-seleccionado-placeholder">
                                    Sin Img
                                </div>

                            )}

                            <div className="producto-seleccionado-info">

                                <h4>{productoSeleccionado.nombre}</h4>

                                <p>
                                    Stock actual:
                                    <strong> {productoSeleccionado.stock}</strong>
                                </p>

                            </div>

                        </div>

                        {/* FORM INLINE */}
                        <form onSubmit={handleSubmit}>

                            <div className="form-inline">

                                <select
                                    className="input-inline small"
                                    value={form.tipo}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            tipo: e.target.value
                                        })
                                    }
                                >

                                    <option value="Entrada">
                                        Entrada
                                    </option>

                                    <option value="Salida">
                                        Salida
                                    </option>

                                </select>

                                <input
                                    className="input-inline xsmall"
                                    type="number"
                                    min="1"
                                    placeholder="Cant."
                                    value={form.cantidad}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            cantidad: e.target.value
                                        })
                                    }
                                />

                                <input
                                    className="input-inline"
                                    placeholder="Descripción"
                                    value={form.descripcion}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            descripcion: e.target.value
                                        })
                                    }
                                />

                                <input
                                    className="input-inline"
                                    placeholder="Referencia"
                                    value={form.referencia}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            referencia: e.target.value
                                        })
                                    }
                                />

                                <button
                                    type="submit"
                                    className="btnGuardarAjuste"
                                    disabled={loading}
                                >

                                    <FontAwesomeIcon
                                        icon={
                                            form.tipo === "Entrada"
                                                ? faArrowUp
                                                : faArrowDown
                                        }
                                    />

                                    {loading
                                        ? "Guardando..."
                                        : "Guardar"}

                                </button>

                            </div>

                        </form>

                        {/* MOVIMIENTOS */}
                        <div className="table-container movimientos-container">

                            <div className="table-header">

                                <h3>
                                    Movimientos del producto
                                </h3>

                            </div>

                            <table className="table">

                                <thead>

                                    <tr>
                                        <th>Fecha</th>
                                        <th>Tipo</th>
                                        <th>Cantidad</th>
                                        <th>Descripción</th>
                                        <th>Referencia</th>
                                    </tr>

                                </thead>

                                <tbody>

                                    {movimientosProducto.length > 0 ? (

                                        movimientosProducto.map((a) => (

                                            <tr key={a.idajuste}>

                                                <td>{a.fechareg}</td>

                                                <td>

                                                    <span
                                                        className={
                                                            a.tipo === "Entrada"
                                                                ? "badge-entrada"
                                                                : "badge-salida"
                                                        }
                                                    >

                                                        {a.tipo}

                                                    </span>

                                                </td>

                                                <td>{a.cantidad}</td>

                                                <td>{a.descripcion}</td>

                                                <td>{a.referencia}</td>

                                            </tr>

                                        ))

                                    ) : (

                                        <tr>

                                            <td
                                                colSpan="5"
                                                style={{
                                                    textAlign: "center",
                                                    padding: "20px"
                                                }}
                                            >
                                                No hay movimientos
                                            </td>

                                        </tr>

                                    )}

                                </tbody>

                            </table>

                        </div>

                    </>

                )}

            </div>

        </div>

    );
}